// import { getClientById, getClientByIdNoState } from "store/reducers/users";
// import { useEffect, useMemo, useState } from "react";

// import { dispatch } from "store";
// import { get } from "lodash";
// import useAuth from "./useAuth";
// import { useSelector } from "store";

// const useUserAuthInfo = (getClientName = false) => {
//   const { user } = useAuth();
//   const [clientData, setClientData] = useState(null);

//   const { clientsById } = useSelector(({ usersmanagement }) => ({
//     clientsById: usersmanagement.clientsById
//   }));

//   console.log("🚀 ~ const{clientsById}=useSelector ~ clientsById:", clientsById);

//   const clientid = useMemo(() => get(user, "data[0].useraccount.clientid"), [user]);
//   const name = useMemo(() => get(user, "data[0].useraccount.name"), [user]);
//   const token = useMemo(() => get(user, "data[0].accessToken.token"), [user]);
//   const userType = useMemo(() => get(user, "data[0].useraccount.usertype"), [user]);
//   const userid = useMemo(() => get(user, "data[0].useraccount.id"), [user]);
//   const parentid = useMemo(() => get(user, "data[0].accessToken.id"), [user]);
//   const accountType = useMemo(() => get(user, "data[0].useraccount.usertype"), [user]);

//   useEffect(() => {
//     if (getClientName && token && clientid && !["ADMIN", "STAFF"].includes(userType)) {
//       getClientByIdNoState(token, clientid)
//         .then((res) => {
//           setClientData(res.data);
//         })
//         .catch(() => {
//           setClientData(null);
//         });
//     }
//   }, [token, clientid]);

//   useEffect(() => {
//     if (token && clientid) {
//       dispatch(getClientById(token, clientid));
//     }
//   }, [token, clientid]);

//   return { user, clientid, token, userType, accountType, userid, parentid, name, clientName: clientData?.name };
// };

// export default useUserAuthInfo;

import { getBillingResponsibilities, getClientById, getClientByIdNoState } from "store/reducers/users";
import { useEffect, useMemo, useState } from "react";

import { dispatch } from "store";
import { get } from "lodash";
import useAuth from "./useAuth";
import { useSelector } from "store";

const useUserAuthInfo = (getClientName = false) => {
  const { user } = useAuth();

  const [clientData, setClientData] = useState(null);

  const billingresponsibilities = useSelector((state) => state.usersmanagement.billingresponsibilities);

  const client = useSelector((state) => state.usersmanagement.clientsById);

  const billings = billingresponsibilities;

  const clientid = useMemo(() => get(user, "data[0].useraccount.clientid"), [user]);
  const token = useMemo(() => get(user, "data[0].accessToken.token"), [user]);
  const userType = useMemo(() => get(user, "data[0].useraccount.usertype"), [user]);

  useEffect(() => {
    const fetchData = async () => {
      if (token && clientid) {
        await dispatch(getBillingResponsibilities(token, clientid));
        await dispatch(getClientById(token, clientid));
      }
    };
    fetchData();
  }, [token, clientid]);

  useEffect(() => {
    const fetchClientName = async () => {
      if (getClientName && token && clientid && !["ADMIN", "STAFF"].includes(userType)) {
        try {
          const response = await getClientByIdNoState(token, clientid);
          setClientData(response.data);
        } catch (error) {
          setClientData(null);
        }
      }
    };

    fetchClientName();

    return () => {
      // Cleanup function to cancel any pending requests or subscriptions
    };
  }, [token, clientid, getClientName, userType]);

  const name = useMemo(() => get(user, "data[0].useraccount.name"), [user]);
  const userid = useMemo(() => get(user, "data[0].useraccount.id"), [user]);
  const parentid = useMemo(() => get(user, "data[0].accessToken.id"), [user]);
  const accountType = useMemo(() => get(user, "data[0].useraccount.usertype"), [user]);

  return { client, user, clientid, token, userType, accountType, billings, userid, parentid, name, clientName: clientData?.name };
};

export default useUserAuthInfo;
